import { gql } from "@apollo/client";
import HTMLCode from "components/common/HTMLCode";
import PageView, { PageViewPropsType } from "components/common/page/PageView";
import ItemView, { ItemViewPropsType } from "components/common/views/ItemView";
import { AppRoutes } from "config/router";
import { AccommodationInvestmentViewPageQuery } from "types/graphql";

const query = gql`
query AccommodationInvestmentViewPage($id: Int!) {
    accommodationWorkInvestment(id: $id) {
        id
        name,
        startDate,
        season {
          name
          id,
          active
        }
        unit
        unitPrice
        total
        quantity
        investmentType
        category
        type
        note
        workers {
          items {
            person {
              name
              id
            }
          }
        }
    }
  }
`;

const AccommodationInvestmentViewPage = () => {
    const pageConfig: PageViewPropsType<AccommodationInvestmentViewPageQuery> = {
        query,
        name: "pages.accommodation.work.investment.view",
        title: "pages.accommodation.work.investment.view",
        queryDataPropertyName: "accommodationWorkInvestment",
        editUrl: AppRoutes.ACCOMMODATION_INVESTMENT_EDIT,
        onDelete: 'accommodationWorkInvestmentDelete',
        onDeleteResponse: AppRoutes.ACCOMMODATION_OVERVIEW_INVESTMENT,
        view: data => {
            const model = data.accommodationWorkInvestment;
            if (!model) return <></>;
            const renderView: ItemViewPropsType['model'] = [
                {
                    name: 'id',
                    items: [
                        {
                            label: 'fields.id.name',
                            value: model.id,
                            name: 'id',
                            propertyType: 'number'
                        },
                        {
                            label: 'fields.name.name',
                            value: model.name,
                            name: 'name',
                            propertyType: 'string'
                        },
                        {
                            label: 'fields.date.name',
                            value: model.startDate,
                            name: 'startDate',
                            propertyType: 'datetime'
                        },
                        {
                            label: '',
                            name: 'fist-separator',
                            value: <hr />
                        },
                        {
                            label: 'fields.quantity.name',
                            value: <span>{model.quantity}<HTMLCode />{model.unit}</span>,
                            name: 'unit',
                        },
                        {
                            label: 'fields.unitPrice.name',
                            value: <span>{model.unitPrice} <HTMLCode code="euro" /> / {model.unit}</span>,
                            name: 'unitPrice',
                        },
                        {
                            label: 'fields.total.name',
                            value: model.total,
                            name: 'total',
                            propertyType: 'money'
                        },
                        {
                            label: '',
                            name: 'second-separator',
                            value: <hr />
                        },
                        {
                            label: 'fields.person.name',
                            value: model.workers?.items?.map(x => x.person.name).join(', '),
                            name: 'seller'
                        },
                        {
                            label: 'fields.investmentType.name',
                            value: model.investmentType,
                            name: 'investmentType',
                        },
                        {
                            label: 'fields.category.name',
                            value: model.category,
                            name: 'category',
                        },
                        {
                            label: 'fields.type.name',
                            value: model.type,
                            name: 'type',
                        },
                        {
                            label: 'fields.season.name',
                            value: model.season.name,
                            name: 'season',
                        },
                        {
                            label: 'fields.note.name',
                            value: model.note,
                            name: 'note',
                            propertyType: 'note'
                        }
                    ]
                }
            ];

            return <ItemView model={renderView} name="pages.accommodation.work.investment.view" view="default" />
        }
    };

    return (
        <PageView {...pageConfig} />
    );
};

export default AccommodationInvestmentViewPage;
